
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"20","height":"20","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M10 4.314L17.192 17.5H2.808L10 4.314zm0-3.48L0 19.166h20L10 .833zm-.833 7.5h1.666v5H9.167v-5zM10 16.459a1.043 1.043 0 010-2.084 1.043 1.043 0 010 2.084z","fill":"#fff"}})])
          )
        }
      }
    